import { ReadSection } from './ReadSection'
import { withReadSection } from './withReadSection'

const ConnectedReadSection = withReadSection(ReadSection)
export { ConnectedReadSection as ReadSection }
